import { useEffect, useState } from "react";
import { Timer } from "lucide-react";

const fmt = (ms) => {
  const s = Math.floor(ms / 1000), d = Math.floor(s / 86400), h = Math.floor((s % 86400) / 3600), m = Math.floor((s % 3600) / 60), x = s % 60;
  const p = (n) => String(n).padStart(2, "0");
  return `${d ? `${d}d ` : ""}${p(h)}:${p(m)}:${p(x)}`;
};

export default function Countdown({ until, testid, onEnd }) {
  const [now, setNow] = useState(Date.now());
  useEffect(() => { const t = setInterval(() => setNow(Date.now()), 1000); return () => clearInterval(t); }, []);
  const left = new Date(until).getTime() - now;
  const ended = left <= 0;
  useEffect(() => { if (ended && onEnd) { onEnd(); } }, [ended]); // eslint-disable-line react-hooks/exhaustive-deps
  return (
    <div className={`inline-flex items-center gap-1 text-xs font-mono font-semibold ${left > 0 ? "text-rose-600" : "text-slate-500"}`} data-testid={testid}>
      <Timer className="h-3.5 w-3.5" />{left > 0 ? `Offer ends in ${fmt(left)}` : "Offer ended"}
    </div>
  );
}
